import React, { useEffect, useState, useRef } from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import styled, { keyframes } from "styled-components";
import "../../fonts/fonts.css";
import "./variables-alt.scss";
import "./reset.scss";
import dataNav from "./navLinks";
import { ArrowUpRight } from "../Arrow";
import IconEnvelope from "../IconEnvelope";
import { ArrowRight } from "../Arrow";
import { useNav } from "./NavContext";
import useLockBodyScroll from "../../hooks/useLockBodyScroll";
import isLandingPage from "../../utilities/isLandingPage";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import Button from "../Button";

const Nav = ({ pathname }) => {

  const [isOpened, setIsOpened] = useState(false);

  const spacerRef = useRef(null);
  const [spacerIsOut, setSpacerIsOut] = useState(false);

  const observerRef = useRef(null);
  const navShouldCollapseRef = useRef(null);

  const [internalNavShouldCollapse, setInternalNavShouldCollapse] = useState(false);

  function setUpObserver() {
    if ( ! spacerRef.current ) return;
    
    let observer;
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0,0.05,0.1,0.2,0.3]
    };
    observer = new IntersectionObserver(( entries ) => {
      if ( entries[0].intersectionRatio < 0.1 ) {
        setSpacerIsOut(true);
      }
      else {
        setSpacerIsOut(false);
      }
    }, options);
    //observer.observe( spacerRef.current );

    return observer;
  }

  useEffect(() => {

    observerRef.current = setUpObserver();

    return () => observerRef.current.disconnect();
    
  }, []);

  const { navShouldCollapse } = useNav();

  useEffect(() => {
    console.log("navShouldCollapse", navShouldCollapse)
    setInternalNavShouldCollapse(navShouldCollapse);
    //navShouldCollapseRef.current = navShouldCollapse;
    if ( ! navShouldCollapse ) {
      observerRef.current.disconnect();
    }
    else {
      observerRef.current.observe(spacerRef.current);
    }
  }, [navShouldCollapse])

  return (
    <>
      <StyledSpacer ref={spacerRef} className={spacerIsOut ? "is-out" : undefined} />
      <StyledHeaderWrap className={spacerIsOut ? "is-out" : undefined} data-pathname={pathname}>
        <SiteHeader isOpened={isOpened} setIsOpened={setIsOpened} />
        <NavBar isOpened={isOpened} setIsOpened={setIsOpened} className={spacerIsOut ? "is-out" : undefined} pathname={pathname} />
      </StyledHeaderWrap>
    </>
  );
};

export default Nav;

const StyledSpacer = styled.div`
  height: 10em;
  margin-bottom: -10em;
  @media ( max-width: 55em ) {
    height: var(--navbar-height);
    margin-bottom: calc(-1 * var(--navbar-height));
  }
`;



const SiteHeader = ({ isOpened, setIsOpened }) => {
  const toggleNav = (e) => {
    e.preventDefault();
    setIsOpened(!isOpened);
  }
  return (
    <StyledSiteHeader className={isOpened ? "is-nav-opened" : undefined}>

      <span>
        {/*<label className={isOpened ? "is-opened" : undefined} htmlFor="nav-toggle" onClick={(e) => toggleNav(e)}>
          <div>
            <span></span>
          </div>
          <span>{isOpened ? "Close" : "Index"}</span>
        </label>*/}
      </span>
      <div>
        <StyledSiteHeaderTitle>
          <div>
            <a title="The Outlaw Ocean Project" href="https://www.theoutlawocean.com">The Outlaw Ocean Project</a>
          </div>
        </StyledSiteHeaderTitle>
      </div>
      <span>
        <a className="subscribe" href="https://theoutlawocean.substack.com" title="Subscribe on Substack" target="_blank" rel="noopener noreferrer">
          <span>Subscribe <ArrowUpRight /></span>
          <span><IconEnvelope /></span>
        </a>
      </span>
    </StyledSiteHeader>
  )
};

const StyledSiteHeaderTitle = styled.div`
  position: relative;
  height: 1.25em;
  contain: paint;
  //padding-top: 0.25em;
  @media ( max-width: 55em ) {
    padding-top: 0.125em;
    transition: filter 0.4s ease;
  }
  > * {
    height: 100%;
  }
  a {
    transition: transform 0.4s ease;
    height: 1em;
    line-height: 1;
    font-family: var(--font-heading);
    font-weight: 700;
    text-transform: uppercase;
    font-size: 1.125em;
    letter-spacing: 0.0125em;
    line-height: 1;
    display: block;
    @media ( max-width: 55em ) {
      //max-width: 9em;
      font-size: 1em;
      margin-bottom: 0.0625em;
    }
  }
  > div {
    position: relative;
    height: 100%;
    display: grid;
    grid-template: 1fr 1fr / 1fr;
    place-items: center;
  }
`;


const StyledSiteHeader = styled.div`
  position: relative;
  z-index: 110;
  //top: 0;
  display: grid;
  height: 100%;
  display: grid;
  grid-template: 1fr / 0.5fr 2fr 0.5fr;
  gap: 0.5em;
  align-items: center;
  padding: 0 var(--gutter);
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  grid-column: 1;
  grid-row: 1;
  /*&:not(.is-nav-opened) {
    box-shadow: inset 0 -1px 0 0 rgba(255,255,255,0.2);
  }*/
  > div:first-of-type {
    text-align: center;
    padding-top: 0.125em;
  }

  [for="nav-toggle"] {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 0.125em;
    cursor: pointer;
    min-width: 2.5em;
    transform: translate3d(-0.625em,0,0);
    margin-top: 0.28em;
    > div {
      position: relative;
      width: 2.5em;
      height: 2.5em;
      span {
        position: relative;
        display: block;
        width: 50%;
        top: calc(50% - 0.09375em);
        left: 25%;
        height: 0.125em;
        background-color: currentColor;
        position: relative;
        z-index: 1000;
        transition-duration: 250ms;
        transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
        transition-delay: initial;
        transition-property: all;
        text-indent: -99999em;
        &::before {
          content: "";
          top: -0.4375em;
          width: calc(100% - 0.25em);
          left: 0;
          height: 0.125em;
          background-color: currentColor;
          position: absolute;
          transition-duration: 250ms;
          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
          transition-delay: initial;
          transition-property: all;
        }
        &::after {
          content: "";
          top: 0.4375em;
          width: calc(100% - 0.5em);
          left: 0;
          height: 0.125em;
          background-color: currentColor;
          position: absolute;
          transition-duration: 250ms;
          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
          transition-delay: initial;
          transition-property: all;
        }
      }
    }
    > span {
      display: none;
      @media ( min-width: 55em ) {
        display: block;
        font-size: 0.875em;
        font-weight: 500;
        line-height: 1;
      }
    }
  }
  [for="nav-toggle"].is-opened > div span {
      background-color: transparent;
  }
  [for="nav-toggle"].is-opened > div span::before {
      top: 0;
      width: 100%;
      transform: rotate(45deg);
  }
  [for="nav-toggle"].is-opened > div span::after {
      top: 0;
      width: 100%;
      transform: rotate(-45deg);
  }

  > span:last-of-type {
    text-align: right;
  }
  .subscribe {
    display: inline-flex;
    font-size: 0.875em;
    font-weight: 500;
    align-items: end;
    gap: 0.25em;
    line-height: 1;
    opacity: 0.7;
    transition: opacity 0.3s ease;
    svg {
      font-size: 0.875em;
      margin-bottom: 0.0125em;
    }
    &:hover {
      text-decoration-line: underline;
      text-decoration-thickness: 0.75px;
      text-underline-offset: 0.1em;
      opacity: 1;
    }
    > span:last-of-type {
      display: none;
    }
  }

  @media ( max-width: 55em ) {
    grid-template: 1fr / 1.5em 1fr 1.5em;
    .subscribe {
      > span:first-of-type {
        display: none;
      }
      > span:last-of-type {
        position: relative;
        display: none;
        transform: translate3d(0,-20%,0);
        svg {
          font-size: 1em;
          margin-bottom: 0;
        }
      }
    }
  }
`;

const NavBar = ({ isOpened, setIsOpened, className, pathname }) => {

  function getClassName() {
    const fullClassName = [className];
    if ( isOpened ) fullClassName.push("is-visible");
    if ( isOpened ) fullClassName.push("is-opened");
    if ( isLandingPage(pathname) ) fullClassName.push("is-landing-page");

    return fullClassName.join(" ");
  }

  const landingPageLink = dataNav.find(({is_landing}) => is_landing === true);
  const filteredNav = dataNav.filter(({is_landing, in_nav_desktop, in_nav_mobile}) => is_landing !== true && (in_nav_desktop || in_nav_mobile));

  function closeNav() {
    setIsOpened(false);
    setActiveDropdown(null);
  }

  const [activeDropdown, setActiveDropdown] = useState(null);

  function handleDropdown(e, slug) {
    if ( activeDropdown === slug ) {
      setActiveDropdown(null);
    }
    else {
      setActiveDropdown(slug);
    }
  }

  const navBarRef = useRef(null);

  useOnClickOutside(navBarRef, () => setActiveDropdown(null));
  
  const containerRef = useRef(null);
  const [collapsedOrder, setCollapsedOrder] = useState(0);

  const checkVisibilityBasedOnViewport = () => {
    const container = containerRef.current;
    const childrenArray = Array.from(container.children).filter(child => 
      child.hasAttribute('data-visible-min')
    );
    
    const childrenArrayLanding = Array.from(container.children).filter(child =>
      child.hasAttribute('data-visible-min-landing')
    );
  
    // Get the base font size to convert em to pixels
    const baseFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  
    const viewportWidthPx = window.innerWidth;
  
    childrenArray.forEach(child => {
      const minEm = parseFloat(child.getAttribute('data-visible-min')) || false;
      const minEmLanding = parseFloat(child.getAttribute('data-visible-min-landing')) || false;

      if ( minEm ) {
        const minWidthPx = minEm * baseFontSize;
        if (viewportWidthPx >= minWidthPx) {
          if ( child.classList.contains("dropdown") && ! child.classList.contains("treat-as-link") ) {
            child.setAttribute("data-visibility", "collapsed")
          }
          else {
            child.setAttribute("data-visibility", "visible")
          }
        } else {
          if ( child.classList.contains("dropdown") && ! child.classList.contains("treat-as-link") ) {
            child.setAttribute("data-visibility", "visible")
          }
          else {
            child.setAttribute("data-visibility", "collapsed")
          }
        }
      }

      if ( minEmLanding ) {
        const minWidthPxLanding = minEmLanding * baseFontSize;
    
        if (viewportWidthPx >= minWidthPxLanding) {
          if ( child.classList.contains("dropdown") && ! child.classList.contains("treat-as-link") ) {
            child.setAttribute("data-visibility-landing", "collapsed")
          }
          else {
            child.setAttribute("data-visibility-landing", "visible")
          }
        } else {
          if ( child.classList.contains("dropdown") && ! child.classList.contains("treat-as-link") ) {
            child.setAttribute("data-visibility-landing", "visible")
          }
          else {
            child.setAttribute("data-visibility-landing", "collapsed")
          }
        }
      }
    });
    
  };

  useEffect(() => {
    // Initial check
    checkVisibilityBasedOnViewport();

    // Add resize event listener to window for responsive adjustments
    window.addEventListener('resize', checkVisibilityBasedOnViewport);

    return () => {
      window.removeEventListener('resize', checkVisibilityBasedOnViewport);
    };
  }, []);


  return (
    <>
      <StyledNavBarBackdrop className={getClassName()} />
      <StyledNavBar className={getClassName()} ref={navBarRef}>
        <div>
          <div className="is-landing">
            <Link className="link link--landing" key={`navbar-${landingPageLink.slug}`} to={`/${landingPageLink.slug}`} title={landingPageLink.label} activeClassName="is-active" onClick={closeNav}>
              {landingPageLink.label}
            </Link>
          </div>
          <hr />
          <div className="toggle-container">
            <NavToggle isOpened={isOpened} setIsOpened={setIsOpened} pathname={pathname} />
          </div>
          <StyledNavBarLinks className={getClassName()} ref={containerRef} data-collapse-order={collapsedOrder}>
            {filteredNav.map(({label, slug, hr, links, feature, visible_min, visible_min_landing, in_nav_desktop, in_nav_mobile, is_link, href}, index) => {
              return (
                <React.Fragment key={`navbar-${slug}-${index}`}>
                  {hr ? (
                    <hr />
                  ) : (
                    <>
                      {links ? (
                        <div className={`dropdown dropdown--${slug}${feature ? " dropdown--feature" : ""}${activeDropdown === slug ? " is-active" : ""} ${in_nav_desktop ? "in-nav-desktop" : ""} ${in_nav_mobile ? "in-nav-mobile" : ""} ${is_link ? "treat-as-link" : ""}`} data-visible-min={visible_min || undefined} data-visible-min-landing={visible_min_landing || undefined}>
                          {/*
                          
                          <Link className="link link--dropdown" key={`navbar-${slug}`} to={`/${slug}`} title={label} activeClassName="is-active">
                            {label}
                            <div></div>
                          </Link>
                          */}
                          {is_link ? (
                            <Link to={`/${slug}`} className="link link--dropdown" onClick={(e) => handleDropdown(e,slug) }>
                              {label}
                              <div></div>
                            </Link>
                          ) : (
                            <span className="link link--dropdown" onClick={(e) => handleDropdown(e,slug) }>
                              {label}
                              <div></div>
                            </span>
                          )}
                          {feature ? (
                            <div className={`dropdown-content dropdown-content--feature}`}>
                              {links.map(({prelabel, label, postlabel, slug, image, feature, category}, index) => (
                                <Link key={`navbar-${slug}-${index}`} to={`${category ? `/${category}` : ""}/${slug}`} title={label} activeClassName="is-active" className={`dropdown__link dropdown__link--feature ${feature ? "is-featured" : ""} `} onClick={closeNav}>
                                  <div>
                                    {image && image}
                                    {/*getInvImage(image)*/}
                                  </div>
                                  <div>
                                    <span>{prelabel}</span>
                                    <strong>{label}</strong>
                                    {postlabel && <small>{postlabel} <i><ArrowRight /></i></small>}
                                  </div>
                                </Link>
                              ))}
                            </div>
                          ) : (
                            <div className={`dropdown-content dropdown-content--simple`}>
                              {links.map(({prelabel, label, postlabel, slug, image, category}, index) => (
                                <Link key={`navbar-${slug}-${index}`} to={`${category ? `/${category}` : ""}/${slug}`} title={label} activeClassName="is-active" className="dropdown__link dropdown__link--simple" onClick={closeNav}>
                                  <div>
                                    <strong>{label}</strong>
                                  </div>
                                </Link>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        <>
                          {href ? (
                            <a 
                              className={`link link--${slug} ${in_nav_desktop ? "in-nav-desktop" : ""} ${in_nav_mobile ? "in-nav-mobile" : ""}`}  
                              key={`navbar-${slug}`} 
                              href={href} 
                              target="_blank"
                              rel="noopener noreferrer"
                              title={label} 
                              activeClassName="is-active" 
                              data-visible-min={visible_min || undefined} 
                              data-visible-min-landing={visible_min_landing || undefined}
                              onClick={closeNav} 
                            >
                              {label}
                            </a>
                          ) : (
                            <Link 
                              className={`link link--${slug} ${in_nav_desktop ? "in-nav-desktop" : ""} ${in_nav_mobile ? "in-nav-mobile" : ""}`}  
                              key={`navbar-${slug}`} 
                              to={`/${slug}`} 
                              title={label} 
                              activeClassName="is-active" 
                              data-visible-min={visible_min || undefined} 
                              data-visible-min-landing={visible_min_landing || undefined}
                              onClick={closeNav} 
                            >
                              {label}
                            </Link>
                          )}
                        </>
                      )}
                    </>
                  )}
                </React.Fragment>
              )
            })}
          </StyledNavBarLinks>
        </div>
      </StyledNavBar>
    </>
  );
};

const NavToggle = ({isOpened, setIsOpened, pathname}) => {

  return (
    <StyledNavToggle className={isOpened ? "is-opened" : undefined} htmlFor="nav-toggle" onClick={(e) => setIsOpened( ! isOpened )}>
      <span>{isLandingPage(pathname) ? "Menu" : ""}</span>
      <div>
        <span></span>
      </div>
    </StyledNavToggle>
  )
};


const StyledNavToggle = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.125em;
  cursor: pointer;
  min-width: 2.5em;
  transform: translate3d(0.625em,0,0);
  margin-top: 0.28em;
  @media ( max-width: 55em ) {
    margin-top: 0.125em;
  }
  > div {
    position: relative;
    width: 2.5em;
    height: 2.5em;
    span {
      position: relative;
      display: block;
      width: 50%;
      top: calc(50% - 0.09375em);
      left: 25%;
      height: 0.125em;
      background-color: currentColor;
      position: relative;
      z-index: 1000;
      transition-duration: 250ms;
      transition-timing-function: cubic-bezier(0.68, -0.55, 0.265, 1.55);
      transition-delay: initial;
      transition-property: all;
      text-indent: -99999em;
      &::before {
        content: "";
        top: -0.4375em;
        width: calc(100% - 0.25em);
        right: 0;
        height: 0.125em;
        background-color: currentColor;
        position: absolute;
        transition-duration: 250ms;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-delay: initial;
        transition-property: all;
      }
      &::after {
        content: "";
        top: 0.4375em;
        width: calc(100% - 0.5em);
        right: 0;
        height: 0.125em;
        background-color: currentColor;
        position: absolute;
        transition-duration: 250ms;
        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        transition-delay: initial;
        transition-property: all;
      }
    }
  }
  > span {
    @media ( max-width: 55em ) {
      display: block;
      font-size: 0.8125em;
      font-weight: 500;
      line-height: 1.5;
      text-transform: uppercase;
      letter-spacing: 0.1em;
    }
  }

  &.is-opened > div span {
    background-color: transparent;
  }
  &.is-opened > div span::before {
    top: 0;
    width: 100%;
    transform: rotate(45deg);
  }
  &.is-opened > div span::after {
    top: 0;
    width: 100%;
    transform: rotate(-45deg);
  }
`;

const StyledNavBarBackdrop = styled.div`
  position: relative;
  //top: 0;
  grid-row: 1 / span 2;
  grid-column: 1;
  height: var(--navbar-height);
  //margin-top: calc(-0.5 * var(--navbar-height));
  z-index: 90;
  transition: transform 0.4s ease;
  transform: translate3d(0,0,0);
  &::before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 100vw;
    margin-left: -50vw;
    background-color: var(--navbar-background-color);;
    z-index: -1;
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
    border-bottom: 1px solid rgba(255,255,255,0.2);
  }
  /*
  &::after {
    -webkit-backdrop-filter: blur(0);
    backdrop-filter: blur(0);
    background-color: rgba(0,0,0,0.6);
    opacity: 0;
  }
  */

`;



const StyledNavBarLinks = styled.div`
  display: inherit;
  gap: inherit;
  align-items: inherit;
  justify-content: inherit;
  width: 100%;

  @media ( max-width: 55em ) {
    position: fixed;
    top: var(--navbar-height);
    right: 0;
    bottom: 0;
    left: 0;
    width: 100vw;
    padding: 1em var(--gutter) 1.5em;
    display: grid;
    grid-auto-rows: min-content;
    grid-template: auto / 1fr 1fr;
    align-items: start;
    align-content: start;
    background-color: var(--navbar-background-color);
    -webkit-backdrop-filter: blur(6px);
    backdrop-filter: blur(6px);
    border-bottom: 1px solid rgba(255,255,255,0.2);
    z-index: 10;
    //height: calc(100vh - var(--navbar-height));
    gap: 1em;
    -webkit-overflow-scrolling: touch;
    overflow-y: auto;
    .dropdown {
      grid-column: 1 / span 2;
    }

    display: none;
    &.is-opened {
      display: grid;
    }
  }

  @media ( max-width: 55em ) {
    .dropdown:not(.in-nav-mobile) {
      display: none !important;
    }
    .dropdown__link--feature.is-featured {
      /*display: grid;
      place-items: center;
      grid-template: 1fr / 1fr;
      min-height: 12em;
      z-index: 0;
      > * {
        grid-row: 1;
        grid-column: 1;
      }
      > div:first-of-type {
        aspect-ratio: auto !important;
        height: 100%;
        width: 100%;
        z-index: -1;
        filter: brightness(0.7);
        border-radius: 1em;
      }
      > div:last-of-type {
        div {
          margin: 1em auto 0;
        }
      }*/
      strong {
        font-size: 1.125em;
        font-weight: 700;
      }
    }
  } 

  @media ( min-width: 55em ) {
    &:not(.is-landing-page) {
      .link[data-visibility="collapsed"] {
        display: none !important;
      }
      .dropdown[data-visibility="visible"] {
        display: block !important;
      }
      .dropdown[data-visibility="collapsed"] {
        display: none !important;
      }
    }
    &.is-landing-page {
      .link[data-visibility-landing="collapsed"] {
        display: none !important;
      }
      .dropdown[data-visibility-landing="visible"] {
        display: block !important;
      }
      .dropdown[data-visibility-landing="collapsed"] {
        display: none !important;
      }
    }
    
  }

  @media ( max-width: 55em ) {
    .link.link--dropdown {
      display: none;
    }
  }
  @media ( min-width: 55em ) {
    .link--dropdown {
      position: relative;
      padding-right: 0.9375em;
      div {
        position: absolute;
        height: 0.375em;
        width: 0.375em;
        contain: paint;
        transform: rotate(45deg);
        right: 0;
        top: 0.45em;
        &::before {
          content: "";
          position: absolute;
          top: -3px;
          right: 0;
          left: -3px;
          bottom: 0;
          border: 1px solid;
        }
      }
    }
    .can-hover & .dropdown:hover,
    .dropdown:active {
      .link--dropdown {
        div {
          transform:  translate3d(0,0.1875em,0) rotate(-135deg);
        }
      }
    }
  }
  

  .dropdown {
    @media ( min-width: 55em ) {
      padding: 0.5em 1em;
      padding: 0.75em 1em;
      margin: 0 -1em;
      .can-hover &:hover .dropdown-content,
      .no-hover &.is-active .dropdown-content {
        display: flex;
      }
      &:not(.in-nav-desktop) {
        display: none !important;
      }
    }
    /*@media ( min-width: 90em ) {
      padding: 0.75em 1em;
    }*/
  }
  .dropdown-content {
    position: relative;
    display: flex;
    gap: 3em;
    padding: 1.5em 0;
    z-index: 10;

    @media ( max-width: 55em ) {
      flex-direction: column;
      gap: 1.5em;
      padding: 0.75em 0;
    }
    @media ( min-width: 55em ) {
      position: absolute;
      top: calc(100% - 2px);
      left: 0;
      right: 0;
      display: none;

      &.dropdown-content--simple {
        justify-content: center;
      }
      
      &::before {
        content: "";
        position: absolute;
        top: 1px;
        bottom: 0;
        width: 100vw;
        left: 50%;
        margin-left: -50vw;
        background-color: var(--navbar-background-color);
        z-index: -1;
        -webkit-backdrop-filter: blur(6px);
        backdrop-filter: blur(6px);
        border-bottom: 1px solid rgba(255,255,255,0.2);
      }
      &::after {
        content: "";
        position: absolute;
        top: 1px;
        right: 0;
        left: 0;
        border-bottom: 1px solid rgba(255,255,255,0.2);
      }
      //box-shadow: inset 0 1px 0 0 rgba(255,255,255,0.2);
      .can-hover &:hover,
      &:active {
        &::after {
          opacity: 1;
        }
      }
    }
  }
  .dropdown__link {
    position: relative;
    z-index: 1;
    strong {
      font-size: 0.9375em;
      font-weight: 500;
    }
    .can-hover &:hover,
    &:active {
      strong {
        text-decoration-line: underline;
        text-decoration-thickness: 0.75px;
        text-underline-offset: 0.1em;
        color: var(--color-uyg);
      }
    }
  }
  .dropdown__link--feature {
    position: relative;
    display: grid;
    grid-template: 1fr / 1fr 2fr;
    gap: 1em;
    align-items: center;
    z-index: 1;
    @media ( max-width: 55em ) {
      grid-template: 1fr / 1fr 3fr;
    }
    > div:first-of-type {
      position: relative;
      aspect-ratio: 1 / 0.75;
      contain: paint;
      border-radius: 0.5em;
      @media ( max-width: 55em ) {
      }
      .gatsby-image-wrapper {
        position: absolute !important;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        height: 100% !important;
        transform: translate3d(0,0,0) scale(1);
        transition: transform 0.4s ease, filter 0.4s ease;
        filter: saturate(1);
      }
    }
    > div:last-of-type {
      display: flex;
      flex-direction: column;
      gap: 0.25em;
      span {
        font-size: 0.75em;
        font-weight: 500;
        text-transform: uppercase;
        opacity: 0.5;
        letter-spacing: 0.1em;
      }
      small {
        font-size: 0.75em;
        opacity: 0.5;
        display: flex;
        gap: 0.5em;
        align-items: center;
        line-height: 1;
        margin-top: 0.375em;
        transition: opacity 0.3s ease;
        i {
          font-size: 0.75em;
          position: relative;
          display: block;
          transform: translate3d(-0.5em,0.125em,0);
          opacity: 0;
          transition: opacity 0.3s ease, transform 0.3s ease;
        }
      }
    }
    .can-hover &:hover,
    &:active {
      > div:first-of-type {
        .gatsby-image-wrapper {
          transform: translate3d(0,0,0) scale(1.1);
          filter: saturate(1.2);
        }
      }
      small {
        opacity: 1;
        i {
          opacity: 1;
          transform: translate3d(0,0.125em,0);
        }
      }
    }
  }
  
`;

const StyledNavBar = styled.nav`
  position: sticky;
  //top: calc(0.5 * var(--navbar-height));
  z-index: 100;
  padding: 0 var(--gutter);
  height: 100%;
  width: 100%;
  max-width: var(--max-width);
  @media ( max-width: 55em ) {
    max-width: 100vw;
  }
  margin: 0 auto;
  //margin-top: calc(-0.5 * var(--navbar-height));
  display: grid;
  align-items: end;
  grid-row: 2;
  grid-column: 1;
  transition: transform 0.4s ease, opacity 0.4s ease;
  > div {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1em;
    height: calc(0.5 * var(--navbar-height));
    @media ( max-width: 55em ) {
      border-top: 1px solid rgba(255,255,255,0.2);
      gap: 0.75em;
    }
    @media ( min-width: 70em ) {
      gap: 1.5em;
    }
    /*@media ( min-width: 55em ) and ( max-width: 90em ) {
      border-top: 1px solid rgba(255,255,255,0.2);
      height: 100%;
      flex-direction: column;
      gap: 0;
    }*/
  }
  &.is-landing-page {
    > div {
      justify-content: center;
      gap: 2em;
      @media ( min-width: 70em ) {
        gap: 3em;
      }
    }
  }
  .link {
    display: block;
    font-size: 0.9375em;
    font-weight: 500;
    white-space: nowrap;
    //opacity: 0.7;
    transition: opacity 0.2s ease;
    .can-hover &[href]:hover,
    &[href]:active {
      text-decoration-line: underline;
      text-decoration-thickness: 0.75px;
      text-underline-offset: 0.1em;
      opacity: 1;
      color: var(--color-uyg);
    }
    &.is-active {
      opacity: 1;
    }
  }
  @media ( max-width: 55em ) {
    .link:not(.in-nav-mobile):not(.link--landing) {
      display: none !important;
    }
  }
  @media ( min-width: 55em ) {
    .link:not(.link--landing):not(.in-nav-desktop):not(.link--dropdown) {
      display: none !important;
    }
  }
  span.link {
    cursor: default;
  }
  .link--landing {
    font-weight: 700;
    font-size: 0.875em;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    margin-right: -0.125em;
    @media ( max-width: 60em ) {
      letter-spacing: normal;
    }
  }
  .is-landing {
    display: flex;
    gap: inherit;
    align-items: inherit;
    white-space: nowrap;
    @media ( max-width: 55em ) {
      padding-right: 0;
    }
    /*@media ( min-width: 55em ) and ( max-width: 90em ) {
      margin-top: auto;
    }*/
    /*&::after {
      content: "";
      display: block;
      width: 1px;
      height: 0.5em;
      background-color: rgba(255,255,255,0.3);
      border: 0;
      margin: 0;
      padding: 0;
    }*/
  }
  &.is-landing-page {
    .is-landing,
    .is-landing + hr {
      display: none;
    }
  }
  hr {
    display: block;
    width: 1px;
    height: 0.5em;
    background-color: rgba(255,255,255,0.3);
    border: 0;
    margin: 0;
    padding: 0;
  }
  @media ( max-width: 55em ) {
    hr {
      display: none;
    }
  }
  /*@media ( min-width: 55em ) and ( max-width: 90em ) {
    .is-landing + hr {
      display: none;
    }
  }*/

  @media ( min-width: 55em ) {
    .toggle-container {
      display: none;
    }
  }

`;


const StyledHeaderWrap = styled.div`
  position: sticky;
  top: 0;
  z-index: 110;
  height: var(--navbar-height);
  display: grid;
  grid-template: calc(0.5 * var(--navbar-height)) calc(0.5 * var(--navbar-height)) / 1fr;

  /*@media ( min-width: 55em ) and ( max-width: 90em ) {
    grid-template: calc(0.4 * var(--navbar-height)) calc(0.6 * var(--navbar-height)) / 1fr;
  }*/
  @media ( min-width: 55em ) {
    .can-hover &.is-out:not(:hover) {
      ${StyledSiteHeaderTitle} {
        & > div * {
          //transform: translate3d(0,-130%,0);
        }
      }

      ${StyledNavBarBackdrop} {
        transform: translate3d(0,-50%,0);
      }
      ${StyledNavBar} {
        transform: translate3d(0,-100%,0);
        opacity: 0;
      }
    }
  }
`;